export default __webpack_public_path__ + "static/media/mode-72.7472a61c.svg";